import { useEffect, useCallback } from 'react'

/**
 * Custom hook for handling escape key press to close modals/popups
 * @param {boolean} isOpen - Whether the modal/popup is currently open
 * @param {function} onClose - Function to call when escape is pressed
 * @param {boolean} enabled - Whether the escape handler is enabled (default: true)
 */
const useEscapeKey = (isOpen, onClose, enabled = true) => {
  const handleKeyDown = useCallback((event) => {
    // Only handle escape key when modal is open and handler is enabled
    if (event.key === 'Escape' && isOpen && enabled) {
      event.preventDefault()
      event.stopPropagation()
      onClose()
    }
  }, [isOpen, onClose, enabled])

  useEffect(() => {
    // Only add listener when modal is open to avoid unnecessary event handling
    if (isOpen && enabled) {
      document.addEventListener('keydown', handleKeyDown)

      return () => {
        document.removeEventListener('keydown', handleKeyDown)
      }
    }
  }, [handleKeyDown, isOpen, enabled])
}

export default useEscapeKey